import { render, staticRenderFns } from "./SQLEditor.vue?vue&type=template&id=325123ef&"
import script from "./SQLEditor.vue?vue&type=script&lang=js&"
export * from "./SQLEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports